import { render } from "./process.vue?vue&type=template&id=4d4d1718&scoped=true&ts=true"
import script from "./process.vue?vue&type=script&lang=ts"
export * from "./process.vue?vue&type=script&lang=ts"

import "./process.vue?vue&type=style&index=0&id=4d4d1718&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4d1718"]])

export default __exports__